import { Component, Input } from '@angular/core';
import {
    FrameworkColumn,
    IEntity,
    ITableCellValueRenderer,
    SafeAny,
} from '@pf/shared-common';
import { UntilDestroy } from '@ngneat/until-destroy';
import { differenceInDays, startOfDay } from 'date-fns';

@UntilDestroy()
@Component({
    selector: 'platform-entity-age-renderer',
    template: `
        <div>{{ createdDate | PfDate: 'datetime' }}</div>
        <div class="age">
            <span class="age-indicator" [ngClass]="age"></span>
            <span class="age-text">{{ ageText }}</span>
        </div>
    `,
    styles: [
        `
            :host {
                .age {
                    display: flex;
                    align-items: center;
                    gap: var(--pf-gap);
                }
                .age-indicator {
                    display: block;
                    width: 8px;
                    height: 8px;
                    border-radius: 100px;
                }
                .recent {
                    background-color: var(--ant-success-color);
                }

                .aging {
                    background-color: var(--ant-warning-color);
                }

                .aged {
                    background-color: var(--ant-error-color);
                }
            }
        `,
    ],
    standalone: false,
})
export class EntityAgeRendererComponent implements ITableCellValueRenderer {
    createdDate?: string;
    age?: 'recent' | 'aging' | 'aged';
    ageText?: string;

    @Input() set value(createdDate: IEntity['createdDate'] | undefined) {
        this.createdDate = createdDate;
        this.calculateAge();
    }
    @Input() column!: FrameworkColumn;
    @Input() row!: SafeAny;

    private calculateAge() {
        if (!this.createdDate) {
            return;
        }

        const days = differenceInDays(
            startOfDay(new Date()),
            startOfDay(new Date(this.createdDate))
        );

        if (days === 0) {
            this.age = 'recent';
            this.ageText = 'Today';
            return;
        }

        if (days <= 3) {
            this.age = 'recent';
            this.ageText = `${days} Day(s)`;
        }
        if (days > 3 && days <= 7) {
            this.age = 'aging';
            this.ageText = `${days} Day(s)`;
        }
        if (days > 7) {
            this.age = 'aged';
            this.ageText = `${days} Day(s)`;
        }
    }
}
